// extracted by mini-css-extract-plugin
export default {"containerCabinet":"Reestrs_containerCabinet__2MCRu"};